export default __webpack_public_path__ + "44d061468d42fdf356aec605dad910aa.png";